import { render, staticRenderFns } from "./DataComparaison.vue?vue&type=template&id=f00151c6&scoped=true"
import script from "./DataComparaison.vue?vue&type=script&lang=js"
export * from "./DataComparaison.vue?vue&type=script&lang=js"
import style0 from "./DataComparaison.vue?vue&type=style&index=0&id=f00151c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00151c6",
  null
  
)

export default component.exports